import React, {useContext} from "react";
import {GlobalContext} from "../contexts/Provider";

const FormHeader = () => {
    const {
        state
    } = useContext(GlobalContext);

    const isProductOrCategoryForm = state.productId || state.categoryId;
    return (
        <div className="flex flex-col gap-6">

            {isProductOrCategoryForm && <p className="headline-4">
                Bei Interesse an diesem Produkt schreiben Sie uns eine Nachricht
            </p>}

            {!isProductOrCategoryForm && <p className="headline-4">
                Haben Sie Fragen oder wünschen Sie eine unverbindliche Beratung? Kontaktieren Sie uns!
            </p>}

            <p className="text-18 letter-spacing-4per line-height-150 text-neutrals-400 font-light">
                Wir beraten Sie gerne und helfen Ihnen, die ideale Lösung für Ihre Bedürfnisse zu finden.
            </p>
        </div>
    );
}
export default FormHeader;
